module.exports = __webpack_public_path__ + "img/google-play-badge_ca-ES.5e2d24d5.png";